var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2083 10.7139L10.3628 12.5594L5.44066 7.63727L7.28613 5.7918C7.96568 5.11225 7.96568 4.01071 7.28613 3.33116L4.21034 0.254503C3.87014 -0.0848344 3.31936 -0.0848344 2.97916 0.254503L0.508083 2.72645C0.100008 3.13365 -0.0696613 3.71488 0.0260493 4.28392C0.535926 7.32404 2.19085 10.5408 4.8255 13.1746C7.46015 15.8092 10.6769 17.4641 13.7161 17.974C14.2852 18.0697 14.8664 17.9001 15.2745 17.492L17.7456 15.0209C18.0849 14.6807 18.0849 14.1299 17.7456 13.7906L14.6689 10.7139C13.9894 10.0344 12.8878 10.0344 12.2083 10.7139",
    fill: "#272226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.bb3dba2538603bb3f088a38b422fab44.svg";
export { ForwardRef as ReactComponent };